export { default as email } from "./email.svg";
export { default as error } from "./error.svg";
export { default as permission } from "./permission.svg";
